export default __webpack_public_path__ + "static/media/View_Icon.7a1f3112.svg";